export default __webpack_public_path__ + "3ffbd4d1f59e2789a9c983df38c87bdd.svg";